/** Documenti: niente downscale, filtri o ricompressione JPEG prima dell'OCR. */
export async function prepareDocumentFile(b64: string, mime: string): Promise<{
  b64: string;
  mime: string;
  sizeBytes: number;
}> {
  const sizeBytes = Math.floor(b64.length * 3 / 4) - (b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0);
  if (sizeBytes > 50_000_000) throw new Error('Il file supera 50 MB. Seleziona un file più piccolo.');
  if (['image/jpeg', 'image/png', 'application/pdf'].includes(mime)) {
    return { b64, mime, sizeBytes };
  }

  // L'archivio multipagina usa pdf-lib, che incorpora JPEG e PNG. Per gli
  // altri formati manteniamo tutti i pixel decodificati in PNG senza perdita.
  // Niente fallback silenzioso a JPEG o a file non leggibili dal server.
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Formato immagine non leggibile. Seleziona una foto JPEG, PNG o un PDF.'));
    image.src = `data:${mime};base64,${b64}`;
  });
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx || !canvas.width || !canvas.height) throw new Error('Impossibile leggere l’immagine. Seleziona un JPEG, PNG o PDF.');
  ctx.drawImage(img, 0, 0);
  const dataUrl = canvas.toDataURL('image/png');
  if (!dataUrl.startsWith('data:image/png;base64,')) throw new Error('Immagine troppo grande per questo browser. Seleziona un JPEG o PDF.');
  return prepareDocumentFile(dataUrl.slice(dataUrl.indexOf(',') + 1), 'image/png');
}
